import { bootstrapApplication } from '@angular/platform-browser';
import { provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter, UrlSerializer } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { ToastMessage } from './app/core/toast.service';
import { IntakeUrlSerializer } from './app/core/intake-url-serializer';
bootstrapApplication(AppComponent, {providers: [provideZoneChangeDetection(), provideAnimations(), provideHttpClient(), provideRouter(routes), {provide:UrlSerializer,useClass:IntakeUrlSerializer}, ToastMessage]}).catch(console.error);
